// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("core.ruffle." + {"110":"b058cfe056b231beb5d3","993":"6027857052655b854471"}[chunkId] + ".js");